import type { ApiParamsDefinition } from '@/api/types/api-definition';
import type {
  PaymentCreateOrderRequest,
  PaymentGuestAddressRequest,
  PaymentGuestCreateOrderRequest,
  PaymentGuestPriceRequest,
  PaymentOrderCouponRequest,
  PaymentOrderPriceRequest,
  PaymentRetainCouponRequest,
  PaymentRetainOrderPopupRequest,
} from '@/api/types/payment';

import { httpRequest, request } from '../request';

type GetFreightRequest = ApiParamsDefinition['POST:/api/order/get_freight']['data'];
type OrderPriceApiRequest = ApiParamsDefinition['GET:/api/order/price']['params'];
type GuestPriceApiRequest = ApiParamsDefinition['POST:/api/order/guest_price']['data'];
type GuestAddressApiRequest = ApiParamsDefinition['POST:/api/order/guest_address']['data'];
type CreateOrderApiRequest = ApiParamsDefinition['POST:/api/order/create']['data'];
type GuestCreateOrderApiRequest = ApiParamsDefinition['POST:/api/order/guest_create']['data'];
type VipCreateOrderRequest = ApiParamsDefinition['POST:/api/customer/vip_create']['data'];
type GetTimeSignRequest = ApiParamsDefinition['GET:/api/customer/get_time_sign']['params'];

const getOrderUtmInfo = () => {
  if (typeof window === 'undefined') return {};
  const latestChannelAttribute = window.latestChannelAttribute;
  const isNotExpired = Number(latestChannelAttribute?.expires) > Date.now();
  return {
    pub_zl_utm_source: isNotExpired
      ? latestChannelAttribute?.pub_zl_utm_source || undefined
      : undefined,
    pub_zl_utm_medium: isNotExpired
      ? latestChannelAttribute?.pub_zl_utm_medium || undefined
      : undefined,
    pub_zl_utm_campaign: isNotExpired
      ? latestChannelAttribute?.pub_zl_utm_campaign || undefined
      : undefined,
    pub_zl_referrer: isNotExpired
      ? latestChannelAttribute?.pub_zl_referrer || undefined
      : undefined,
    pub_zl_page:
      isNotExpired || latestChannelAttribute?.expires === -1
        ? latestChannelAttribute?.pub_zl_page || undefined
        : undefined,
    pub_landing_page: latestChannelAttribute?.pub_landing_page || undefined,
  };
};

export default {
  getFreight: (data: GetFreightRequest) => httpRequest('POST:/api/order/get_freight', { data }),
  orderPrice: (data: PaymentOrderPriceRequest) =>
    httpRequest(
      'GET:/api/order/price',
      { params: data as OrderPriceApiRequest },
      { errorMsg: false },
    ),
  guestPrice: (data: PaymentGuestPriceRequest) =>
    httpRequest(
      'POST:/api/order/guest_price',
      { data: data as GuestPriceApiRequest },
      { errorMsg: false },
    ),
  guestAddress: (data: PaymentGuestAddressRequest) =>
    httpRequest(
      'POST:/api/order/guest_address',
      { data: data as GuestAddressApiRequest },
      { errorMsg: false },
    ),
  orderCouponList: (data: PaymentOrderCouponRequest) =>
    httpRequest('GET:/api/order/coupon', { params: data }),
  createOrder: (data: PaymentCreateOrderRequest) =>
    httpRequest(
      'POST:/api/order/create',
      {
        data: {
          ...data,
          utm_info: getOrderUtmInfo(),
        } as CreateOrderApiRequest,
      },
      { errorMsg: false },
    ),
  guestCreateOrder: (data: PaymentGuestCreateOrderRequest) =>
    httpRequest(
      'POST:/api/order/guest_create',
      {
        data: {
          ...data,
          utm_info: getOrderUtmInfo(),
        } as GuestCreateOrderApiRequest,
      },
      { errorMsg: false },
    ),
  vip_createOrder: (data: VipCreateOrderRequest) =>
    httpRequest('POST:/api/customer/vip_create', { data }),
  // 获取前台模块的时间标记
  getTimeSign: (data: GetTimeSignRequest) =>
    httpRequest('GET:/api/customer/get_time_sign', { params: data }),
  // payment页面退出时送优惠券(条件：当前无优惠券可用且商品金额大于49，第二次退出（由接口判断）)
  paymentRetainCoupon: (data?: PaymentRetainCouponRequest) =>
    httpRequest('POST:/api/order/retain_coupon', { data: data || {} }, { errorMsg: false }),
  // 订单子单更新处方
  updateItemPresImage: (data: any) =>
    request('/api/order/update_order_item_prescriptions_image', 'post', data),
  // payment页挽留弹窗显示
  retainOrderPopupApi: (data: PaymentRetainOrderPopupRequest) =>
    httpRequest('POST:/api/order/retain_order_popup', { data }),
  // 订单工单变更列表
  orderChangeList: (data: any) => request('/api/order/mj_workorder', 'get', data),
};
